import { makeAutoObservable, observable } from 'mobx';

type AutoTourState = {
  welcomeModalOpen: boolean;
  isExpired: boolean;
  activateModalOpen: boolean;
  guideExpand: boolean;
  classificationProgress: number;
  alarmProgress: number;
  fbSubscribeProgress: number;
  intelligentReplyProgress: number;
  fbH5Progress: number;
  fbToOncallProgress: number;
  fbToTapdProgress: number;
  intelligentModelModalOpen: boolean;
  stepOpen: boolean;
  classifyFinish: boolean;
};

export type AutoTourStateKeys = keyof AutoTourState;

/** 新手指引 STORE */
class AutoTourStore {
  /** 欢迎页弹窗开启 */
  @observable public welcomeModalOpen = false;
  /** 标志是否过期 */
  @observable public isExpired = false;
  /** 智能分类进度 */
  @observable public classificationProgress = 0;
  /** 智能告警进度 */
  @observable public alarmProgress = 0;
  /** 反馈订阅进度 */
  @observable public fbSubscribeProgress = 0;
  /** 智能回复进度 */
  @observable public intelligentReplyProgress = 0;
  /** 反馈H5页接入进度 */
  @observable public fbH5Progress = 0;
  /** 反馈转Oncall进度 */
  @observable public fbToOncallProgress = 0;
  /** 反馈转tapd进度 */
  @observable public fbToTapdProgress = 0;
  /** 转激活弹窗开启 */
  @observable public activateModalOpen = false;
  @observable public guideExpand = false;
  @observable public intelligentModelModalOpen = false;
  @observable public stepOpen = false;
  @observable public classifyFinish = false;

  public constructor() {
    makeAutoObservable(this);
  }

  /** 通用设置方法 */
  public setState<K extends AutoTourStateKeys>(key: K, value: this[K]) {
    this[key] = value;
  }

  /** 批量设置方法 */
  public setStates<K extends keyof AutoTourState>(
    states: Pick<AutoTourState, K>
  ) {
    Object.entries(states).forEach(([key, value]) => {
      this.setState(key as K, value as this[K]);
    });
  }

  /** 欢迎页弹窗开启 */
  public setWelcomeModalOpen(open: boolean) {
    this.setState('welcomeModalOpen', open);
  }
  /** 转激活弹窗开启 */
  public setActivateModalOpen(open: boolean) {
    this.setState('activateModalOpen', open);
  }
}

/** 新手指引 STORE */
const AUTO_TOUR_STORE = new AutoTourStore();

export type TAutoTourStore = typeof AUTO_TOUR_STORE;

export default AUTO_TOUR_STORE;
